import React from "react";
import "./IntroSection.scss";
import {ReactComponent as TrustPilotLogo} from "../../../assets/icons/trustpilotLogo.svg";
import {ReactComponent as RatingsFourHalf} from "../../../assets/icons/ratingsFourHalf.svg";
import CountUp from "react-countup";
import {useLocation} from "react-router-dom";
const IntroSection = () => {
  const handleNavigationLinks = (url) => {
    window.open(url, "_blank");
  };

  const location = useLocation();

  return (
    <div className="introSectionContainer">
      <div className="introSectionWrapper">
        <div className="topSectionIntro">
          <p className="title">ALPHA CAPITAL</p>
          <h2 className="motto">
            Trade Smarter,<span>Trade Alpha</span>
          </h2>
          <p className="stats">
            Join <span>1.2 Million+</span> traders who trust Alpha Capital Group. Improve with an Analyst account up to <span>$200,000 </span>
            and earn up to <span>80%</span> of your simulated profits.
          </p>
        </div>
        <div className="midSectionIntro">
          <button
            className="normalButton"
            onClick={() => {
              location.pathname === "/riz" ? handleNavigationLinks("https://app.alphacapitalgroup.uk/signup/RIZ") : handleNavigationLinks("https://app.alphacapitalgroup.uk/");
            }}
          >
            Start Alpha Evaluation
          </button>
          <button
            className="normalButton"
            onClick={() => {
              location.pathname === "/riz" ? handleNavigationLinks("https://app.alphacapitalgroup.uk/signup/RIZ") : handleNavigationLinks("https://app.alphacapitalgroup.uk/");
            }}
          >
            Take Your Free Trial
          </button>
        </div>
        <div className="bottomSectionIntro">
          <div className="ratingsBox">
            <p>Excellent</p>
            <RatingsFourHalf
              className="trustPilotRatingBtn"
              // style={{ cursor: "pointer" }}
              onClick={() => handleNavigationLinks("  https://www.trustpilot.com/review/alphacapitalgroup.uk?utm_medium=trustbox&utm_source=Horizontal")}
            />

            <TrustPilotLogo
              className="trustPilotRatingBtn"
              style={{cursor: "pointer"}}
              onClick={() => handleNavigationLinks("  https://www.trustpilot.com/review/alphacapitalgroup.uk?utm_medium=trustbox&utm_source=Horizontal")}
            />
          </div>
          <div className="statsBox">
            <div className="statDiv">
              <p className="statNum">
                <CountUp
                  start={0}
                  end={140}
                />
                +
              </p>
              <p className="statLabel">Countries</p>
            </div>
            <div className="statDiv">
              <p className="statNum">
                {" "}
                <CountUp
                  start={0}
                  end={100000}
                  separator=","
                />
                +
              </p>
              <p className="statLabel">Qualified Analysts</p>
            </div>
            <div className="statDiv">
              <p className="statNum">
                {" "}
                <CountUp
                  start={0}
                  end={1.2}
                  decimals={1}
                />
                &nbsp; Million+
              </p>
              <p className="statLabel"> Traders</p>
            </div>
            {/* <div className="statDiv">
              <p className="statNum">
                {" "}
                <CountUp
                  start={0}
                  end={10}
                />
                K
              </p>
              <p className="statLabel">Virtual Strategies</p>
            </div> */}
            <div className="statDiv">
              <p className="statNum">
                $
                <CountUp
                  start={0}
                  end={100}
                />
                M+
              </p>
              <p className="statLabel">Performance Fees</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSection;
